import MDTypography from './MDTypography';
import { theme } from 'oems/theme';

export function DataGridCell(props) {
  var rowId = props.rowId;

  const handleClick = (e) => {
    if (props.itemClicked) {
      props.itemClicked(rowId);
    }
  };
  return (
    <MDTypography
      font="Roboto,Helvetica"
      sx={{
        fontSize: '13px',
        cursor: (theme) => {
          return props.main ? 'pointer' : 'default';
        },
        color: (theme) => {
          return props.main ? theme.palette.brand.main : '#7B809A';
        },
        fontWeight: (theme) => {
          return props.main ? '700' : 'normal';
        },
        fontFamily: (theme) => {
          return props.main ? 'Roboto,Helvetica' : 'Roboto,Helvetica';
        },
      }}
      onClick={handleClick}
      variant="button"
      {...props}
    >
      {props.children}
    </MDTypography>
  );
}

export default DataGridCell;
